import { createI18n } from 'vue-i18n'
import { nextTick } from 'vue'
import { getLanguage, getCookieKeyPrefix, normalizeLanguage } from '@/utils/common'
import { getUrlParam } from '@/utils/index'
import { getAppLocale } from '@/api'
import Cookies from 'js-cookie'

// 与后端的global_locale_cookie_key匹配
const globalLocaleCookieKey = getCookieKeyPrefix() + '_ASGlobalLocale_FF117B9D62'
const localeCookieKey = getCookieKeyPrefix() + '_AsLocalLocale_FF117B9D62'

// IE 每次页面初始化直接使用简体中文，跳过 URL、Cookie 和浏览器默认语言。
const isIEBrowser = (typeof document !== 'undefined' && Boolean(document.documentMode)) ||
  (typeof navigator !== 'undefined' && /MSIE|Trident/i.test(navigator.userAgent || ''))
let ieLocale = 'zh-cn'

export function getLocale() {
  if (isIEBrowser) {
    return ieLocale
  }
  let locale = null
  if (document.domain !== 'localhost') {
    locale = Cookies.get(globalLocaleCookieKey)
  } else {
    locale = Cookies.get(localeCookieKey)
  }
  return (
    normalizeLanguage(getUrlParam('lang')) ||
    normalizeLanguage(locale) ||
    getLanguage()
  )
}
const defaultLocale = getLocale()
function loadLocaleMessages() {
  const locales = require.context('./lang', true, /[A-Za-z0-9-_,\s]+\.js$/i)
  const messages = { 'zh-cn': {}}

  // 首先加载主语言文件
  locales.keys().forEach((key) => {
    // console.log(key)
    if (key.indexOf('/module/') === -1) {
      const matched = key.match(/([A-Za-z0-9-_]+)\./i)
      if (matched && matched.length > 1) {
        const locale = matched[1]
        messages[locale] = locales(key)['default']
      }
    }
  })

  // 然后加载模块化的语言文件
  locales.keys().forEach((key) => {
    // console.log(key)
    if (key.indexOf('/module/') !== -1) {
      // 解析模块路径
      const pathParts = key.split('/')
      const locale = pathParts[2] // zh-cn
      const modulePath = pathParts.slice(3, -1) // ['components', 'chat']
      const fileName = pathParts[pathParts.length - 1].replace(/\.[^/.]+$/, '') // chat

      // 确保目标对象存在
      let target = messages[locale]
      if (!target) {
        messages[locale] = {}
        target = messages[locale]
      }

      // 根据路径创建嵌套对象
      modulePath.forEach(part => {
        if (!target[part]) {
          target[part] = {}
        }
        target = target[part]
      })

      // 将翻译内容合并到目标对象
      target[fileName] = locales(key)['default']
    }
  })

  console.log('Loaded i18n messages:', messages)
  return messages
}

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  // IE 仅初始化默认中文；后续跟随手动切换或账户偏好，避免请求和布局回读旧 URL / Cookie。
  if (isIEBrowser) {
    ieLocale = locale
  }
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  document.querySelector('html').setAttribute('lang', locale)
  nextTick(() => {
    document.getElementById('agent_store').setAttribute('data-lang', locale)
  })
}

// Keep local fallback strings when the server returns only part of a locale tree.
function mergeLocaleMessages(target, source) {
  Object.keys(source || {}).forEach(key => {
    const sourceValue = source[key]
    const targetValue = target[key]
    const canMerge = sourceValue && typeof sourceValue === 'object' && !Array.isArray(sourceValue) &&
      targetValue && typeof targetValue === 'object' && !Array.isArray(targetValue)

    if (canMerge) {
      mergeLocaleMessages(targetValue, sourceValue)
    } else {
      target[key] = sourceValue
    }
  })
  return target
}

export async function setLocale(i18n, locale) {
  if (locale !== 'zh-cn') {
    try {
      const r = await getAppLocale({
        locale: locale.replace('-', '_')
      })
      if (r.code === 0) {
        let messages = i18n.global.getLocaleMessage(locale)
        messages = mergeLocaleMessages(messages, r.data)
        i18n.global.setLocaleMessage(locale, messages)
        console.log(r)
      }
    } catch (error) {
      console.error('Error updating fold status:', error)
      i18n.locale = locale
    }
    // i18n.locale = locale
  }
  console.log(process.env.VUE_APP_DOMAIN)
  if (document.domain !== 'localhost') {
    Cookies.set(globalLocaleCookieKey, locale, {
      domain: '.' + process.env.VUE_APP_DOMAIN,
      path: '/'
    })
  } else {
    Cookies.set(localeCookieKey, locale)
  }
  return nextTick()
}
window.locateInit = false
export async function initLocale(locale) {
  if (!window.locateInit) {
    if (locale !== 'zh-cn') {
      await setLocale(i18n, locale)
    }
    setI18nLanguage(i18n, locale)
    window.locateInit = true
  }
}
const numberFormats = {
  'en-us': {
    currency: {
      style: 'currency',
      currency: 'USD'
    }
  },
  'ja-jp': {
    currency: {
      style: 'currency',
      currency: 'JPY',
      currencyDisplay: 'symbol'
    }
  },
  'zh-cn': {
    currency: {
      style: 'currency',
      currency: 'CNY',
      currencyDisplay: 'symbol'
    }
  }
}
const i18n = createI18n({
  numberFormats,
  legacy: false,
  globalInjection: true,
  locale: defaultLocale,
  fallbackLocale: 'en-us',
  messages: loadLocaleMessages()
})
// ElementLocale.i18n
export default i18n
